import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import LoginPage from "../../components/auth/LoginPage";
import { useAuth } from "../../context/AuthContext";

const HOME_BY_ROLE = {
  admin: "/admin",
  athlete: "/athlete/dashboard",
  scout: "/scout/dashboard",
};

export const getLoginDestination = (role, requestedPath) => {
  const home = HOME_BY_ROLE[role] || "/";
  if (!requestedPath) return home;

  const rolePrefix = `/${role}`;
  return requestedPath === rolePrefix || requestedPath.startsWith(`${rolePrefix}/`)
    ? requestedPath
    : home;
};

const LoginRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();

  const handleLogin = (session) => {
    signIn();
    navigate(
      getLoginDestination(session?.role, location.state?.from?.pathname),
      { replace: true },
    );
  };

  return (
    <LoginPage
      onLogin={handleLogin}
      onGoToSignUp={() => navigate("/signup")}
      onForgotPassword={() => navigate("/forgot-password")}
    />
  );
};

export default LoginRoute;
